const translations = {
  "en": {
    "Hot Stocks": "Hot Stocks",
    "Hot Themes": "Hot Themes"
  },
  "zh-tw": {
    "Hot Stocks": "熱門股票",
    "Hot Themes": "熱門主題"
  }
};

export default translations;
